var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubirArchivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 187.308,
    height: 147.717,
    viewBox: "0 0 187.308 147.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #316094;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1717",
    "data-name": "Rect\\xE1ngulo 1717",
    className: "cls-1",
    width: 187.308,
    height: 147.717,
    transform: "translate(149.945 257.482)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictograma_-_Subir_",
    "data-name": "Pictograma - Subir ",
    className: "cls-2",
    transform: "translate(-149.945 -257.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4469",
    "data-name": "Trazado 4469",
    className: "cls-3",
    d: "M313.809,392.252l-1.9-3.52a40.6,40.6,0,0,0-29.724-74.966l-2.05.546-.425-2.079a63.531,63.531,0,1,0-107.321,57.534l-2.838,2.815A67.531,67.531,0,1,1,283.184,309.41a44.6,44.6,0,0,1,30.625,82.842"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1716",
    "data-name": "Rect\\xE1ngulo 1716",
    className: "cls-3",
    width: 4,
    height: 71.773,
    transform: "translate(242.456 333.426)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4470",
    "data-name": "Trazado 4470",
    className: "cls-3",
    d: "M278.128,370.382l-33.7-34.138-33.675,32.581-2.781-2.875,36.516-35.339,36.486,36.956Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubirArchivo);
export default __webpack_public_path__ + "static/media/subirArchivo.da778392edae738bc0832319a99833cb.svg";
export { ForwardRef as ReactComponent };